module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0118-81991457c61ca30ac62d4929d984357d.jpg";